import { FC } from 'react';

import { usePermissions } from '@mint-lib/profile-helpers';

import { StaticCurrencySpan, StaticNumericSpan } from '@myn/mui';

import { CurrencyFieldProps } from '../types.js';
import TextVariant from './TextVariant.jsx';

type Props = Pick<
  CurrencyFieldProps,
  'scale' | 'currency' | 'value' | 'decimalLimit' | 'placeholder'
>;

const CurrencyVariant: FC<Props> = ({
  scale,
  currency,
  value,
  decimalLimit,
  placeholder,
}) => {
  const { getPermissionField } = usePermissions();

  const isNonFinancialUser = !getPermissionField('financialDataFeature');
  const formattingOptions = {
    minDecimals: decimalLimit,
    maxDecimals: decimalLimit,
    min: 0,
  };

  if (isNonFinancialUser) {
    return <TextVariant scale={scale} value="---" placeholder="" />;
  }

  if (!value && value !== 0) {
    return <TextVariant scale={scale} value={null} placeholder={placeholder} />;
  }

  // handle a case when journey currency wasn't get because of a server error
  if (!currency) {
    return <StaticNumericSpan number={value} options={formattingOptions} />;
  }

  return (
    <StaticCurrencySpan
      number={value}
      currency={currency}
      options={formattingOptions}
    />
  );
};

export default CurrencyVariant;
